(function ($, njm) {
    'use strict';
    njm.views.plLogin = Backbone.View.extend({

        events: {
            'click #login1': 'login1',
            'click #login2': 'sendOtp',
            'click #login3': 'verifyCodeEvent',
            'click .password-visibility': 'passwordVisibility',
            'click #resendCode': 'resendCode',
            'click #changeDelivery': 'changeDelivery',
            'click #cancel1': 'backToSection',
            'click #cancel2': 'backToSection',
            'keypress #password': 'capslockHint',
            'click input[name="otp-method"]': 'hasOtpMethod',
            'click .file-a-claim': 'fileAClaim',
        },
        
        initialize: function () {
            try {
                const destinationUrl = $('#login1').data('destinationurl');
                // Check if in Experience Editor mode
                const isExperienceEditor = document.getElementById('hidIsExperienceEditor')?.value === "";
                const otpEntryVisible = $("#otp-entry").is(":visible");
                const currentTimestamp = Date.now();
                const locCheck = decodeURIComponent(window.location.search);
                const gotoParam = this.urlParam('goto', locCheck);
                const dctimestamp = this.urlParam('_dc', locCheck);
                const customParam = this.urlParam('context', locCheck);
                const navigateParam = this.urlParam('navigateto', locCheck);
                const dcTimeOut = 5 * 60 * 1000;// Timeout constant (5 minutes)
                if (navigateParam && navigateParam!= '')
                {
                    $('#login1').attr("data-navigateto", navigateParam);
                    $('#login3').attr("data-navigateto", navigateParam);
                }   
                if (isExperienceEditor && !otpEntryVisible) {
                    if (!gotoParam || !dctimestamp || (dctimestamp && (currentTimestamp - dctimestamp > dcTimeOut))) {
                        const urlObj = new URL(destinationUrl);
                        urlObj.searchParams.set('_dc', currentTimestamp);
                        if (customParam && customParam != '') {
                            urlObj.searchParams.set('context', customParam);
                        }
                        if (navigateParam && navigateParam != '') {
                            urlObj.searchParams.set('navigateto', navigateParam);
                        }
                        var processedUrl = decodeURIComponent(urlObj.toString());
                        this.redirect(processedUrl);
                    }

                    setInterval(function () {
                        if (!dctimestamp || (dctimestamp && (currentTimestamp - dctimestamp > dcTimeOut))) {
                            const urlObj = new URL(destinationUrl);
                            urlObj.searchParams.set('_dc', currentTimestamp);
                            if (customParam && customParam != '') {
                                urlObj.searchParams.set('context', customParam);
                            }
                            if (navigateParam && navigateParam != '') {
                                urlObj.searchParams.set('navigateto', navigateParam);
                            }
                            var processedUrl = decodeURIComponent(urlObj.toString());
                            this.redirect(processedUrl);
                        }
                    }, 300000);
                }

                if (window.location.href.indexOf('vercd') >= 0) {
                    this.verifyCode(window.location.href.split('vercd')[1].substring(1));
                } else {
                    $('#userid').keypress(function (e) {
                        if (e.keyCode === 13) {
                            $('#login1').click();
                        }
                    });
                    $('#password').keypress(function (e) {
                        if (e.keyCode === 13) {
                            $('#login1').click();
                        }
                    });
                }

                if (localStorage.Csschkbox && localStorage.Csschkbox != '') {
                    $('#rememberUserID').attr('checked', 'checked');
                    $('#userid').val(localStorage.Cssusername);
                } else {
                    $('#rememberUserID').removeAttr('checked');
                    $('#userid').val('');
                }
                if (sessionStorage.FromClaimPage && sessionStorage.FromClaimPage == 'true') {
                    $('#file-login-claim').hide();
                    if (sessionStorage.ClaimFor && sessionStorage.ClaimFor == "auto-glass-only") {
                        $('#file-auto-glass-only-claim').show();
                        $('#file-auto-claim').hide();
                        $('#file-property-claim').hide();
                    }
                    if (sessionStorage.ClaimFor && sessionStorage.ClaimFor == "auto") {
                        $('#file-auto-glass-only-claim').hide();
                        $('#file-auto-claim').show();
                        $('#file-property-claim').hide();
                    }
                    if (sessionStorage.ClaimFor && sessionStorage.ClaimFor == "property") {
                        $('#file-auto-glass-only-claim').hide();
                        $('#file-auto-claim').hide();
                        $('#file-property-claim').show();
                    }
                }

                /**
                * Disable IE's capslock indicator since we provide one
                **/
                if ($('.comp-login #password') && document.msCapsLockWarningOff === false) {
                    document.msCapsLockWarningOff = true;
                }
                /**
               * RECAPTCHA CODE- NEED TO BE REMOVED
               **/
                // load the script
                $.getScript('https://www.google.com/recaptcha/enterprise.js?onload=renderCaptcha&render=explicit', function () { });
                // this is the callback function
                var getRecaptchaResponse = function (response) {
                    if (response) {
                        $('#login1').data('token', response);
                        document.getElementById('warning').style.display = 'none';
                        document.getElementById('recaptcha-container').style.border = '';
                    }
                    else {
                        $('#login1').data('token', "");
                    }
                };

                // render the recaptcha
                var renderCaptcha = function () {
                    grecaptcha.enterprise.render('recaptcha-container', {
                        sitekey: document.getElementById('hidCaptchaSiteKey').value,
                        //Sitekey- Prod
                        //sitekey: '6Lc3QMwgAAAAAAPgtjRleekyEiG5ObJiOI9Eza2D',
                        callback: getRecaptchaResponse
                    });
                };

                // map the internal function to the window
                // so that the callback registered in the 
                // link below can be called by JSONP.
                window.renderCaptcha = renderCaptcha;
                /**
              * RECAPTCHA CODE- NEED TO BE REMOVED
              **/

                window.addEventListener("dd_response_unload", function () {
                    $('#login1').click();
                });


                njmClientClickTracking.trackPageName(window.location.href, document.referrer);
            }
            catch (ex) {
                njmClientClickTracking.logErrorGeneric("initialize", ex.name, "Exception on initialize", "Anonymous", ex.stack);
                throw ex;
            }
        },
        stringTrim: function (x) {
            return x.replace(/^\s+|\s+$/gm, '');
        },
        /**
        * Parse return error message for Login
        **/
        checkLoginError: function (response) {
            var status = response.status,
                msg = response.responseText ? JSON.parse(response.responseText).message : '';
            var userId = this.stringTrim(document.getElementById('userid').value);
            var errorMsg = document.getElementById('hidDefaultErrorMessage').value;
            if (status === 400 && msg) {
                if (response.getResponseHeader("NJM_CAPTCHA_REQUIRED")) {
                    errorMsg = document.getElementById('hidLockoutWarning').value;
                } else if (msg.indexOf('Authentication Failed') >= 0) {
                    errorMsg = document.getElementById('hidInvalidLogin').value;
                    if (msg.indexOf('You will be locked out') >= 0) {
                        //errorMsg = errorMsg + ' To avoid being locked out, please use the “Forgot User ID?” and/or “Forgot Password?” links to obtain your User ID or a new Password.';
                        errorMsg = errorMsg + document.getElementById('hidAvoidLockout').value
                    }
                } else if (msg.indexOf('Your account has been locked') >= 0) {
                    errorMsg = document.getElementById('hidAccountHasBeenLocked').value;
                    //errorMsg = 'You have been locked out of your account. Please contact our customer service department during our business hours.';
                } else if (msg.indexOf('Your account is locked') >= 0) {
                    errorMsg = document.getElementById('hidAccountIsLocked').value
                    //errorMsg = 'Your account is locked. Please contact our Customer Service department during our business hours.';
                } else if (msg.indexOf('You have not successfully completed your registration') >= 0) {
                    errorMsg = document.getElementById('hidRegistrationUnsuccessful').value;
                    //errorMsg = 'You have not successfully completed your registration. Please click the link in the e-mail we have sent you to complete the registration process or contact our Customer Service department during our business hours.';
                } else if (msg.indexOf('Your account has been deactivated') >= 0) {
                    errorMsg = document.getElementById('hidAccountDeactivated').value;
                    //errorMsg = 'Your account has been deactivated. Please contact our Customer Service department during our business hours.';
                }
                else if (msg.indexOf('OTP is locked') >= 0) {
                    errorMsg = document.getElementById('hidAccountHasBeenLocked').value;
                }
                else {
                    errorMsg = document.getElementById('hidInvalidLogin').value;
                    //errorMsg = 'The User ID and/or Password you are entering are invalid.';
                }
            }
            njmClientClickTracking.logErrorGeneric("checkLoginError", msg, status, userId, errorMsg);
            return errorMsg;
        },

        /**
       * STEP 1: Login API Call
       * **/
        login1: function (e) {
            e.preventDefault();
            $('#loading').show();
            var userId = document.getElementById('userid').value;
            njmClientClickTracking.linkClickedWithUserID(e.currentTarget, userId);
            var loginApiUrl = $(e.currentTarget).data('loginapiurl');
            var destinationUrl = $(e.currentTarget).data('destinationurl');
            var otpApiUrl = $(e.currentTarget).data('otpapiurl');
            var token = $(e.currentTarget).data('token');
            this.login(loginApiUrl, destinationUrl, otpApiUrl, token, false);
        },
        login: function (loginApiUrl, destinationUrl, otpApiUrl, token, keepWarning) {
            var self = this;
            
            var OauthUrl = $('#login1').data('navigateto') != '' ? $('#login1').data('oauthurl') +'?navigateto=' + $('#login1').data('navigateto') : $('#login1').data('oauthurl');
            var logoutUrl = $('#login1').data('logouturl');
            const openAmSessionTimeout = parseInt(document.getElementById('OASessionTimeout')?.value);
            
            var userID = this.stringTrim(document.getElementById('userid').value),
                pass = this.stringTrim(document.getElementById('password').value),
                valid = true;
            if (document.getElementById("rememberUserID").checked) {
                // save username and password
                localStorage.Cssusername = userID;
                localStorage.Csschkbox = document.getElementById("rememberUserID").checked;
            } else {
                localStorage.Cssusername = '';
                localStorage.Csschkbox = '';
            }

            if (this.stringTrim(userID) === '') {
                document.getElementById('userid').style.border = '1px solid #cc0000';
                valid = false;
            } else {
                document.getElementById('userid').style.border = '';
            }

            if (this.stringTrim(pass) === '') {
                document.getElementById('password').style.border = '1px solid #cc0000';
                valid = false;
            } else {
                document.getElementById('password').style.border = '';
            }

            var headers = {};
            if (token == '' || token.length == 0) {
                headers = { 'Content-Type': 'application/json' };
                if ($("#recaptcha-container").is(":visible")) {
                    valid = false;
                    document.getElementById('recaptcha-container').style.border = '1px solid #cc0000';
                }
                else {
                    //Valid Login
                    document.getElementById('recaptcha-container').style.border = '';
                    document.getElementById('recaptcha-container').style.display = 'none';
                }
            }
            else {
                headers = {
                    'Content-Type': 'application/json',
                    'NJM_VERIFICATION_TOKEN': token,
                    'NJM_VERIFICATION_ACTION': 'login'
                }
                document.getElementById('recaptcha-container').style.border = '';
                document.getElementById('recaptcha-container').style.display = 'none';
                grecaptcha.enterprise.reset();
                $('#login1').data('token', "");
            }
            if (!valid) {
                document.getElementById('warningText').innerHTML = document.getElementById('hidFieldWarning').value //'Please fill in the highlighted fields to continue.';
                document.getElementById('warning').style.display = 'block';
                $('#loading').hide();
            }
            else {
                $.ajax({
                    type: 'POST',
                    url: loginApiUrl,
                    headers: headers,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: JSON.stringify({
                        'UserID': userID,
                        'Password': pass,
                        'device': device()
                    }),
                    success: function (response) {

                        //Check if device is new or existing device.

                        //If New device call OTP(GET) method.
                        if (!response.hasOwnProperty('url')) {
                            ////store the loginresponse in session to retrieve in save method
                            //console.log(JSON.stringify(response));
                            //sessionStorage.setItem('loginResponse', JSON.stringify(response));
                            self.otpMethod(otpApiUrl, self, response);
                            njmClientClickTracking.screenLoadingsuccessful("otp-method", userID);
                            // Redirect after openAmSessionTimeout to Logoff screen
                            setTimeout(() => {
                                window.location.replace(logoutUrl);    //Get LogOFF link from UI
                            }, openAmSessionTimeout);
                        }
                        else if (response.hasOwnProperty('url')) {
                            document.getElementById('warning').style.display = 'none';
                            $('#loading').hide();
                            //self.sendUserAnalytics(response, document.getElementById('login1'));
                            self.sendUserAnalytics(response, 'login1');
                            self.getOauthToken(destinationUrl, OauthUrl, self);
                        }
                        if (!keepWarning) {
                            document.getElementById('warning').style.display = 'none';
                        }
                        $('#loading').hide();
                    },
                    error: function (response) {
                        var msg = response.responseText ? JSON.parse(response.responseText).message : '';
                        var errorResponse = self.checkLoginError(response);
                        document.getElementById('warningText').innerHTML = errorResponse;
                        document.getElementById('warning').style.display = 'block';
                        $('#loading').hide();
                        if (!document.getElementById("rememberUserID").checked) {
                            document.getElementById('userid').value = '';
                        }
                        document.getElementById('password').value = '';
                        //reCAPTCHA
                        if (response.status == 400 && response.getResponseHeader("NJM_CAPTCHA_REQUIRED")) {
                            $('#loading').hide();
                            document.getElementById('recaptcha-container').style.display = 'block';
                        }
                        njmClientClickTracking.logErrorGeneric("login", msg, response.status, userID, errorResponse);
                    }
                });
            }
        },
        /**
        * STEP 2:GET OTP Methods
        * **/
        otpMethod: function (otpMethodUrl, self, loginResponse) {
            var userId = document.getElementById('userid').value;
            $.ajax({
                type: 'GET',
                url: otpMethodUrl,
                xhrFields: {
                    withCredentials: true
                },
                success: function (response) {
                    if (Array.isArray(response)) {
                        self.fillOtpMethods(response);
                        self.hasOtpMethod();
                        document.getElementById('login-box').style.display = 'none';
                        document.getElementById('otp-method').style.display = 'block';
                        if (($("#otp-method").is(":visible"))) {
                            $('.comp-login').addClass('hide-content');
                        }
                        document.getElementById('warningOtp').style.display = 'none';
                        $('#loading').hide();
                    }
                },
                error: function (response) {
                    var msg = response.responseText ? JSON.parse(response.responseText).message : '';
                    var warningText = document.getElementById('hidDefaultErrorMessage').value;//"We’re sorry, an error has occurred. Please try again later.";
                    document.getElementById('warningText').innerHTML = warningText;
                    document.getElementById('warning').style.display = 'block';
                    $('#loading').hide();
                    document.getElementById('login-box').style.display = 'block';
                    document.getElementById('otp-method').style.display = 'none';
                    njmClientClickTracking.logErrorGeneric("otpMethod", msg, response.status, userId, warningText);
                }
            });
        },

        /**
       * Fill OTP Method Radio Buttons
       **/
        fillOtpMethods: function (response) {
            response.forEach(function (item, index) {
                if (item !== null) {
                    var divHtml = '<div class="radio-container">';
                    var radioHtml = '<input type="radio" id="otp-method' + index + '" name="otp-method" value="' + item.id + '">';
                    var labelHtml = '<label for="otp-method' + index + '">' + item.value + '</label>';
                    var spanHtml = '<span class="radio"></span>';
                    divHtml += radioHtml;
                    divHtml += labelHtml;
                    divHtml += spanHtml;
                    divHtml += '</div>';
                    $('#otp-method-radios').append(divHtml);
                    if (item.preselect) {
                        $("#otp-method" + index).prop('checked', true);
                    }
                }
            });
        },

        //STEP 3: POST Selected OTP Method
        sendOtp: function (e) {
            $('#loading').show();
            var UserId = document.getElementById('userid').value;
            njmClientClickTracking.linkClickedWithUserID(e.currentTarget, UserId);
            document.getElementById('warningOtp2').style.display = 'none';
            var self = this;
            var otpPostApiUrl = $(e.currentTarget).data('otpapiurl');
            $.ajax({
                type: 'POST',
                url: otpPostApiUrl,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    'id': $("input[name='otp-method']:checked").val()
                },
                success: function (response, status, request) {
                    document.getElementById('warningTextOtp').style.display = 'none';
                    $('#loading').hide();
                    var idVal = $("input[name='otp-method']:checked").attr("id");
                    var selectedOTPText = $("label[for='" + idVal + "']").text();
                    var successMessage = document.getElementById('hidSuccessMessage').value;
                    successMessage = successMessage.replace("{0}", selectedOTPText);
                    document.getElementById('success-message').innerHTML = successMessage;
                    document.getElementById('code').value = '';
                    document.getElementById('otp-method').style.display = 'none';
                    document.getElementById('otp-entry').style.display = 'block';
                    if (($("#otp-entry").is(":visible"))) {
                        $('.comp-login').addClass('hide-content');
                    }
                    document.getElementById('code').style.border = '';
                    njmClientClickTracking.screenLoadingsuccessful("otp-entry", UserId);
                },
                error: function (response) {
                    var msg = response.responseText ? JSON.parse(response.responseText).message : '';
                    document.getElementById('warningTextOtp').innerHTML = document.getElementById('hidDefaultErrorMessage').value; //'We’re sorry, an error has occurred. Please try again later.';
                    document.getElementById('warningOtp').style.display = 'block';
                    $('#loading').hide();
                    njmClientClickTracking.logErrorGeneric("sendOTP", msg, response.status, UserId, document.getElementById('hidDefaultErrorMessage').value);
                }
            });
        },

        //STEP 4: Submit OTP Code
        verifyCodeEvent: function (e) {
            var validateOtpUrl = $(e.currentTarget).data('validateotpurl');
            var destinationUrl = $(e.currentTarget).data('destinationurl');
            var saveDeviceUrl = $(e.currentTarget).data('loginsaveurl');
            //var OauthUrl = $(e.currentTarget).data('oauthurl');
            var OauthUrl = $(e.currentTarget).data('navigateto') != '' ? $(e.currentTarget).data('oauthurl') + '?navigateto=' + $(e.currentTarget).data('navigateto') : $(e.currentTarget).data('oauthurl');
            var UserId = document.getElementById('userid').value;
            njmClientClickTracking.linkClickedWithUserID(e.currentTarget, UserId);
            this.verifyOtpCode(validateOtpUrl, destinationUrl, saveDeviceUrl, OauthUrl);
        },

        /**
        * Sends entered code to API for verification and redirects to CSS if valid
        **/
        verifyOtpCode: function (validateOtpUrl, destinationUrl, saveDeviceUrl, OauthUrl) {
            var self = this;
            $('#loading').show();
            if (document.getElementById('code').value === '') {
                document.getElementById('code').style.border = '1px solid #cc0000';
                document.getElementById('warningTextOtp2').innerHTML = document.getElementById('hidFieldWarning').value//'Please fill in the highlighted fields to continue';
                document.getElementById('warningOtp2').style.display = 'block';
                $('#loading').hide();
            } else {
                document.getElementById('code').style.border = '';
                $.ajax({
                    type: 'POST',
                    url: validateOtpUrl,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        code: document.getElementById('code').value
                    },
                    success: function () {
                        document.getElementById('warningOtp2').style.display = 'none';
                        $('#loading').hide();
                        self.saveDevice(saveDeviceUrl, destinationUrl, OauthUrl);
                    },
                    error: function (response) {
                        var msg = response.responseText ? JSON.parse(response.responseText).message : '',
                            //error = msg.indexOf('Invalid') >= 0 ? 'The Validation Code you entered is not recognized. Please check the OTP and try again or click on resend.' :
                            //        msg.indexOf('Expired') >= 0 ? 'The Validation Code you entered has not expired. Please click on resend.' : msg.indexOf('Locked') >= 0 ?"Locked":
                            //            'We’re sorry, an error has occurred. Please try again later.';
                            error = msg.indexOf('Invalid') >= 0 ? document.getElementById('hidInvalidOTP').value :
                                msg.indexOf('Expired') >= 0 ? document.getElementById('hidExpiredOTP').value : msg.indexOf('Locked') >= 0 ? "OTP is locked" :
                                    document.getElementById('hidDefaultErrorMessage').value;
                        var userId = self.stringTrim(document.getElementById('userid').value);
                        if (error.indexOf('OTP is locked') >= 0) {
                            $('#loading').hide();
                            document.getElementById('otp-entry').style.display = 'none';
                            document.getElementById('warningText').innerHTML = document.getElementById('hidOTPIsLocked').value;
                            document.getElementById('warning').style.display = 'block';
                            document.getElementById('login-box').style.display = 'block';
                        }
                        else {
                            document.getElementById('code').value = '';
                            document.getElementById('warningTextOtp2').innerHTML = error;
                            document.getElementById('warningOtp2').style.display = 'block';
                            $('#loading').hide();
                        }
                        njmClientClickTracking.logErrorGeneric("verifyOtpCode", msg, response.status, userId, error);
                    }
                });
            }
        },
        //Save Device 
        saveDevice: function (saveDeviceUrl, destinationUrl, OauthUrl) {

            var self = this;
            $('#loading').show();
            $.ajax({
                type: 'POST',
                url: saveDeviceUrl,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    save: $("#rememberDevice").is(':checked')
                },
                success: function (response) {
                    document.getElementById('warningOtp2').style.display = 'none';
                    $('#loading').hide();
                    self.sendUserAnalytics(response, 'login3');
                    self.getOauthToken(destinationUrl, OauthUrl, self);
                },
                error: function () {
                    document.getElementById('code').value = '';
                    document.getElementById('warningTextOtp2').innerHTML = document.getElementById('hidDefaultErrorMessage').value; //'We’re sorry, an error has occurred. Please try again later.';
                    document.getElementById('warningOtp2').style.display = 'block';
                    $('#loading').hide();
                    var userId = document.getElementById('userid').value;
                    njmClientClickTracking.logErrorGeneric("saveDevice", msg, response.status, userId, error);
                }
            });

        },

        //Resend Code to Selected OTP Method
        resendCode: function (e) {
            e.preventDefault();
            var resendCode = $('#resendCode').parent();

            if (!resendCode.hasClass('disabled')) {
                var resendLoading = $('#resendCode .loading');
                var resendSuccess = $('#resendCode .success');
                var UserId = document.getElementById('userid').value;
                njmClientClickTracking.linkClickedWithUserID(e.currentTarget, UserId);
                document.getElementById('code').style.border = '';
                var self = this;
                var otpPostApiUrl = $(e.currentTarget).data('otpapiurl');
                resendLoading.show();
                resendCode.addClass('disabled');

                $.ajax({
                    type: 'POST',
                    url: otpPostApiUrl,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        'id': $("input[name='otp-method']:checked").val()
                    },
                    success: function (response) {
                        document.getElementById('code').value = '';
                        document.getElementById('warningOtp2').style.display = 'none';
                        resendLoading.hide();
                        resendSuccess.removeClass('hidden');
                        resendCode.addClass('hidden');
                        var resendTimeout = setTimeout(function () {
                            resendCode.removeClass('disabled hidden');
                            resendSuccess.addClass('hidden');
                        }, 10000);
                    },
                    error: function (response) {
                        document.getElementById('code').value = '';
                        document.getElementById('success-message').innerHTML = "";
                        document.getElementById('warningTextOtp2').innerHTML = document.getElementById('hidDefaultErrorMessage').value; //'We’re sorry, an error has occurred. Please try again later.';
                        document.getElementById('warningOtp2').style.display = 'block';
                        resendLoading.hide();
                        resendCode.removeClass('disabled');
                    }
                });
            }

        },

        changeDelivery: function () {
            $('#otp-entry').hide();
            $('#otp-method').show();
            if (($("#otp-method").is(":visible"))) {
                $('.comp-login').addClass('hide-content');
            }
            $("input:radio[name='otp-method']").prop('checked', false);

            this.hasOtpMethod();
        },

        passwordVisibility: function (e) {
            var self = e.currentTarget;
            if ($(self).text() === 'Show') {
                $('.comp-login input#password').attr('type', 'text');
                $(self).text('Hide');
            } else {
                $('.comp-login input#password').attr('type', 'password');
                $(self).text('Show');
            }
        },

        isCapsLockOn: function (e) {
            if (e.originalEvent.getModifierState("CapsLock")) {
                return true;
            } else {
                return false;
            }
        },

        capslockHint: function (e) {
            if (this.isCapsLockOn(e) && ($('#warning').css('display') === 'block')) {
                $(".capslock-hint").css('display', 'inline-block');
            } else {
                $(".capslock-hint").css('display', 'none');
            }
        },

        /**
        * In future, needs to get URL from API return in previous step as parameter
        * In future, needs to get URL from API return in previous step as parameter
        **/
        redirect: function (inpurl) {
            if (window.location.search.indexOf('mobile=y') >= 0) {
                inpurl = inpurl + '?mobile=y';
            }
            window.location.replace(inpurl);
        },

        sendUserAnalytics: function (response, login) {
            var userId = this.stringTrim(document.getElementById('userid').value);
            var loginButton = document.getElementById(login);
            //Parse Response
            if (response !== null && response.policies !== null && response.policies.length > 0) {
                var inputPolicyTypes = [];
                var policyStatus = "Active";
                response.policies.forEach(function (item) {
                    if (item !== null) {
                        policyStatus = "InActive";
                        if (item.policyStatus === 1) {
                            policyStatus = "Active";
                        }
                        var policy = {
                            "policyType": item.policyType,
                            "policyStatus": policyStatus
                        }
                        inputPolicyTypes.push(policy);
                    }
                });
                njmClientClickTracking.trackUser(loginButton, userId, inputPolicyTypes);
            }
        },

        backToSection: function (e) {
            var backSection = $(e.currentTarget).data('backsection');
            var currentSection = $(e.currentTarget).data('currentsection');
            if (backSection === 'login-box') {
                this.cancelReset(e);
                return;
            }
            var UserId = document.getElementById('userid').value;
            njmClientClickTracking.linkClickedWithUserID(e.currentTarget, UserId);
            document.getElementById("warning").style.display = "none";
            document.getElementById(currentSection).style.display = "none";
            document.getElementById(backSection).style.display = "block";
        },

        /**
       * Redirects to given location. Handles Cancel and Registration button clicks
       **/
        cancelReset: function (e) {
            var destinationUrl = $(e.currentTarget).data('href');
            var UserId = document.getElementById('userid').value;
            njmClientClickTracking.linkClickedWithUserID(e.currentTarget, UserId);
            if (destinationUrl !== undefined && destinationUrl !== '') {
                window.location = destinationUrl;
            }
        },

        getOauthToken: function (destUrl, OauthUrl, self) {
            var goto = "";
            if (location.href.indexOf('agent') !== -1) {
                goto = decodeURIComponent(location.href.substr(location.href.indexOf('agent'))).replace("#", "%20%25");
            }
            self.redirect(OauthUrl + goto);
        },

        urlParam: function (name, param) {
            var paramCheck;
            name = name.toLowerCase();

            if (!param) {
                var location = window.location.search,
                    index = location.indexOf('=');
                paramCheck = location.substring(0, index).toLowerCase() + location.substring(index);
            }
            else paramCheck = param;

            var results = new RegExp('[\?&]' + name + '=([^&#]*)')
                .exec(paramCheck);

            return (results !== null) ? results[1] || 0 : false;
        },
        getUrlParameter: function (name, search, encodeResult) {
            search = search || window.location.search;
            var params = new URLSearchParams(search);
            var param = params.get(name) || '';
            if (encodeResult) {
                param = encodeURIComponent(param);
            }
            return param;
        },

        getOriginalRequestQueryString: function () {
            var val = this.getUrlParameter('original_request_url');
            try {
                var url = new URL(val);
                return url.search;
            }
            catch (e) {
                console.error(e);
                return '';
            }
        },

        hasOtpMethod: function () {
            if (!$("input:radio[name='otp-method']").is(":checked")) {
                $("#login2").attr('disabled', 'disabled');
            }
            else {
                $("#login2").removeAttr('disabled', 'disabled');
            }
        },
        fileAClaim: function () {
            sessionStorage.ClaimFor = '';
            sessionStorage.FromClaimPage = 'false';
        }
       

    });
})(jQuery, njm);

